var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.types,"menu-props":{ top: false, offsetY: true },"label":"Type"},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})}
var staticRenderFns = []

export { render, staticRenderFns }